var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63887 6.67617C10.9637 6.67617 12.0377 5.60216 12.0377 4.27729C12.0377 2.95243 10.9637 1.87842 9.63887 1.87842C8.314 1.87842 7.23999 2.95243 7.23999 4.27729C7.23999 5.60216 8.314 6.67617 9.63887 6.67617Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63885 6.67628C10.9637 6.67628 12.0377 5.60226 12.0377 4.2774C12.0377 3.25254 11.395 2.37779 10.4907 2.03418",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9154 10.0461C14.0889 10.8276 13.2965 12.3349 11.8867 12.3349H6.59226C5.18241 12.3349 4.39006 10.8276 5.56347 10.0461C6.616 9.34507 7.88002 8.93652 9.23946 8.93652C10.5989 8.93652 11.8629 9.34507 12.9154 10.0461Z",
    fill: "#DBEAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60231 6.20071C7.03845 6.20071 8.20266 5.03649 8.20266 3.60036C8.20266 2.16422 7.03845 1 5.60231 1C4.16617 1 3.00195 2.16422 3.00195 3.60036C3.00195 5.03649 4.16617 6.20071 5.60231 6.20071Z",
    fill: "#DBEAFE",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58535 9.85411C10.8573 10.7013 9.99842 12.3352 8.47016 12.3352H2.73108C1.20282 12.3352 0.34393 10.7013 1.61589 9.85411C2.75682 9.09422 4.127 8.65137 5.60062 8.65137C7.07424 8.65137 8.44443 9.09422 9.58535 9.85411Z",
    fill: "#DBEAFE",
    stroke: "#1D4ED8",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24908 12.3351H11.8866C13.2965 12.3351 14.0888 10.8277 12.9154 10.0462C12.5914 9.83042 12.2474 9.64233 11.8866 9.48535",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.cb2e8a4691885bb738f02e45e69277a8.svg";
export { ForwardRef as ReactComponent };